import { render, staticRenderFns } from "./StockLinkedDeliveryNotesTable.vue?vue&type=template&id=1155480f&scoped=true"
import script from "./StockLinkedDeliveryNotesTable.vue?vue&type=script&lang=js"
export * from "./StockLinkedDeliveryNotesTable.vue?vue&type=script&lang=js"
import style0 from "./StockLinkedDeliveryNotesTable.vue?vue&type=style&index=0&id=1155480f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155480f",
  null
  
)

export default component.exports